var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGreenHeart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 53,
    viewBox: "0 0 51 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 1618874578 2",
    clipPath: "url(#clip0_1502_2390)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.93096 52.5527C4.93096 52.5527 1.35408 28.1864 0.292729 21.4479C-1.0443 12.961 1.92611 0.0344636 14.8897 4.80381e-05C27.8534 -0.0343675 28.3634 18.4331 24.9174 23.9396C24.9174 23.9396 42.2919 6.6216 48.8599 18.6877C55.4278 30.7538 38.3497 39.4954 29.8865 44.2103C17.9497 50.8732 4.93096 52.5527 4.93096 52.5527Z",
    fill: "#A8BA52"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1502_2390"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 53,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHeart);
export default __webpack_public_path__ + "static/media/greenHeart.4d5735e0d80a541bf51e263884ba0688.svg";
export { ForwardRef as ReactComponent };